import { render, staticRenderFns } from "./CMSContactFormLogList.vue?vue&type=template&id=3c86349c&"
import script from "./CMSContactFormLogList.vue?vue&type=script&lang=js&"
export * from "./CMSContactFormLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports